export const messages = {
  default:
    "Select the application / device type / domain account you would want to request. You may use the search box and filter options to easily find what you are looking for.",
  no_system:
    "You haven’t selected anything yet. Please select one or more systems to proceed.",
  system_addedd:
    "Select all the systems needed. Once done, the next page will show you the list of all the systems you have selected.",
  single_user_only_app: "[[APPLICATION_NAME]] is for single user only.",
};
